export default "__VITE_ASSET__6d4df2ef__"